import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialVolumeCurveConfiguration,
    VolumeCurveConfiguration,
} from './VolumeCurveConfiguration';
import { selectVolumeCurveState } from '../selectors';

export const buildVolumeCurveConfigSlice = () =>
    buildConfigSlice<VolumeCurveConfiguration>(
        WidgetType.VOLUME_CURVE,
        selectVolumeCurveState,
        initialVolumeCurveConfiguration
    );

export const useVolumeCurveConfigSlice = () =>
    useConfigSlice(buildVolumeCurveConfigSlice());

export type VolumeCurveConfigPayloadType =
    WidgetConfigSliceActionPayloadType<VolumeCurveConfiguration>;
